import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import OidcCallback from "../views/OidcCallback";
import OidcSilentRenew from "../views/OidcSilentRenew";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";
import store from "../store/index";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/library",
    name: "Library",
    component: () =>
      import(/* webpackChunkName: "library" */ "../views/Library.vue"),
    meta: {
      isPublic: true
    }
  },
  {
    path: "/progress",
    name: "Progress",
    component: () =>
      import(/* webpackChunkName: "progress" */ "../views/Progress.vue")
  },
  {
    path: "/progress/:studentGuid",
    name: "StudentProgress",
    component: () =>
      import(/* webpackChunkName: "progress" */ "../views/Progress.vue")
  },
  {
    path: "/library/:bookId/sections/:sectionId",
    name: "Section",
    component: () =>
      import(/* webpackChunkName: "library" */ "../views/Section.vue"),
    meta: {
      isPublic: true
    }
  },
  {
    // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
    path: "/oidc-callback",
    name: "oidcCallback",
    component: OidcCallback
  },
  {
    // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
    path: "/oidc-silent-renew",
    name: "oidcSilentRenew",
    component: OidcSilentRenew,
    meta: {
      isPublic: true
    }
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () =>
      import(/* webpackChunkName: "tc" */ "../views/PrivacyPolicy.vue"),
    meta: {
      isPublic: true
    }
  },
  {
    path: "/terms",
    name: "Terms",
    component: () => import(/* webpackChunkName: "tc" */ "../views/Terms.vue"),
    meta: {
      isPublic: true
    }
  },
  {
    path: "/admin",
    name: "Admin",
    component: () =>
      import(/* webpackChunkName: "admin" */ "../views/Admin.vue")
  },
  {
    path: "/settings",
    name: "Settings",
    component: () =>
      import(/* webpackChunkName: "settings" */ "../views/Settings.vue")
  },
  {
    path: "/students",
    name: "Students",
    component: () =>
      import(/* webpackChunkName: "students" */ "../views/Students.vue")
  },
  {
    path: "/students/:studentGuid/recordings",
    name: "StudentRecordings",
    component: () =>
      import(
        /* webpackChunkName: "students" */ "../views/StudentRecordings.vue"
      )
  },
  {
    path: "/tutors",
    name: "Tutors",
    component: () =>
      import(/* webpackChunkName: "tutors" */ "../views/Tutors.vue")
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store));

export default router;
